import { Box, Typography, Grid, TextField } from '@mui/material';
import { IDam } from '../../../services/api/dams/DamServices';

interface TechnicalCharacteristicsProps  {
    data: IDam;
}

export const TechnicalCharacteristics = ({data}: TechnicalCharacteristicsProps) => {

    return(
        <Box padding={0}>
            <Box>
                <Typography variant='h5'>Características Técnicas</Typography>
            </Box>
            <Box padding={1} marginTop={0}>
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <TextField
                            inputProps={{ readOnly: true }}
                            value={data?.elevacao_crista}
                            label='Elevação da crista (m)'
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            inputProps={{ readOnly: true }}
                            value={data?.comprimento_crista}
                            label='Comprimento da crista (m)'
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            inputProps={{ readOnly: true }}
                            value={data?.altura_maxima_crista}
                            label='Altura máxima da crista (m)'
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            inputProps={{ readOnly: true }}
                            value={data?.inclinacao_talude_montante}
                            label='Inclinação do talude de Montante'
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            inputProps={{ readOnly: true }}
                            value={data?.inclinacao_talude_jusante}
                            label='Inclinação do talude de Jusante'
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            inputProps={{ readOnly: true }}
                            value={data?.berma}
                            label='Bermas'
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            inputProps={{ readOnly: true }}
                            value={data?.volume_estrutura}
                            label='Volume da estrutura (m³)'
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            inputProps={{ readOnly: true }}
                            value={data?.area_estrutura}
                            label='Área da estrutura (m²)'
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            inputProps={{ readOnly: true }}
                            value={data?.volume_macico}
                            label='Volume do maciço (m³)'
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            inputProps={{ readOnly: true }}
                            value={data?.composicao_macico}
                            label='Composição do maciço'
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            inputProps={{ readOnly: true }}
                            value={data?.sistema_dranagem}
                            label='Sistemas de drenagem'
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            inputProps={{ readOnly: true }}
                            value={data?.extravasor}
                            label='Extravasor'
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            inputProps={{ readOnly: true }}
                            value={data?.impermeablizacao}
                            label='Impermeabilização'
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            inputProps={{ readOnly: true }}
                            value={data?.fundacao}
                            label='Fundação'
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            inputProps={{ readOnly: true }}
                            value={data?.curso_dagua_barrado}
                            label='Curso d’água interceptado/barrado'
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            inputProps={{ readOnly: true }}
                            value={data?.vazao_residual_curso_dagua}
                            label='Vazão residual do curso d’água'
                            fullWidth
                        />
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
};